import { useTranslations } from 'next-intl';

import Badge from '@/components/label/Badge';

import { isMovieReleaseDateNew } from '@/helpers/movie-helper';

type MovieReleaseBadgeProps = {
    movieReleaseDate: string;
};

function MovieReleaseBadge(props: MovieReleaseBadgeProps) {
    const { movieReleaseDate } = props;

    const t = useTranslations();

    if (isMovieReleaseDateNew(movieReleaseDate)) {
        return <Badge name={t('common.new')} />;
    }

    return null;
}

export default MovieReleaseBadge;
